// One-line label for a shipping / billing address, for selects and admin notices.
// Single owner so the wizard's address picker and any running-order notice render
// the same string.
export function addressLabel(a) {
  if (!a) return '';
  return [a.company_name, a.full_name, a.address_line1, a.address_line2, a.postal_code, a.city, a.country]
    .filter(Boolean)
    .join(', ');
}